export default __webpack_public_path__ + "static/media/maitre_gims_brise.c69ad5e4.mp3";